import { Checkbox } from 'antd';
import classNames from 'classnames';
import { ReactNode, useEffect, useState } from 'react';
import getFormatMessage from '../../locales/get-format-message';
import { ISelectOption } from '../../model';
import { CommonSearchInput } from '../input';
import styles from './index.module.scss';

interface IProps {
  selectedValues?: any[];
  header?: ReactNode;
  showSearch?: boolean;
  searchPlaceholder?: string;
  showSelectAll?: boolean;
  list: ISelectOption[];
  onSearch?: (text: string) => void;
  onSelectChanged?: (vals: any[]) => void;
  onSingleSelectChanged?: (val: any) => void;
}

export const CommonListMenu = (props: IProps) => {
  const {
    selectedValues = [],
    header,
    list = [],
    showSearch = false,
    showSelectAll = false,
    onSelectChanged,
    onSingleSelectChanged,
    onSearch,
    searchPlaceholder = '',
  } = props;
  const [filterList, setFilterList] = useState<ISelectOption[]>(list);
  const [search, setSearch] = useState<string>('');

  useEffect(() => {
    doFilterList();
  }, [list, search]);

  useEffect(() => {
    // const newList = doFilterList()
    // const allVals = newList.map(item => item.value)
    // onSelectChanged?.(selectedValues.filter(item => allVals.includes(item)))
    // onSelectChanged?.([])
  }, [search]);

  const doFilterList = () => {
    const newList = list.filter(
      (item) =>
        item.text?.toLowerCase().includes(search.toLowerCase()) || !search
    );
    setFilterList(newList);
    return newList;
  };

  const renderList = () => {
    if (!filterList.length) {
      return (
        <div className={styles.listItem}>
          {getFormatMessage('no_data_available')}
        </div>
      );
    }
    return filterList.map((item) => {
      const isSelected = selectedValues.includes(item.value);
      return (
        <div
          key={item.value}
          className={classNames(styles.listItem, {
            [styles.selected]: isSelected,
          })}
          onClick={() => {
            const newVals = isSelected
              ? selectedValues.filter((val) => val !== item.value)
              : [...selectedValues, item.value];
            onSelectChanged?.(newVals);
            onSingleSelectChanged?.(item.value);
          }}
        >
          <Checkbox checked={isSelected} />
          <span className={styles.itemContent}> {item.label}</span>
        </div>
      );
    });
  };

  return (
    <div className={styles.menu}>
      <div className={styles.header}>{header}</div>
      {showSelectAll && (
        <div
          className={classNames(styles.listItem, {
            [styles.selected]: selectedValues.length === filterList.length,
          })}
          onClick={() => {
            if (selectedValues.length !== list.length) {
              onSelectChanged?.(filterList.map((item) => item.value));
              return;
            }
            onSelectChanged?.([]);
          }}
        >
          <Checkbox
            checked={
              selectedValues.length > 0 &&
              selectedValues.length === filterList.length
            }
            indeterminate={
              selectedValues.length > 0 &&
              selectedValues.length !== filterList.length
            }
          />
          <span>显示所有数据</span>
        </div>
      )}
      {showSearch && (
        <div className={styles.search}>
          <CommonSearchInput
            bordered={false}
            allowClear
            placeholder={searchPlaceholder}
            onChange={(ev) => {
              setSearch(ev.target.value);
              onSearch?.(ev.target.value);
            }}
          />
        </div>
      )}

      <div className={classNames(styles.body)}>{renderList()}</div>
      <div className={styles.footer}>总计{filterList.length || 0}条数据</div>
    </div>
  );
};
